import * as React from 'react';
import { Dispatch } from 'react-redux';
import { MultiAppAuthenticationTitle } from '../../../components/MultiAppAuthentication/styles';
import { Translate } from 'react-redux-i18n';
import { StoreState } from '../../../reducers';
import { loadGallery } from '../../../containers/MultiAppAuthentication/actions';
import { PageOverlay } from '../../../components/PageOverlay/styles';
import Utils from '../../../utils';
import {
	StyledMultiAppAuthenticationPopup, CloseButton, AccessibleAppSelectWrapper,
	AccessibleAppSelect, AccessibleAppSelectIcon
} from '../../../components/MultiAppAuthentication/Popup/styles';
import { Api } from '../../../typings/api';
import { AuthenticateButton } from '../../Authentication/styles';

export interface MultiAppAuthenticationPopupProps {
	accessibleApps: Api.AspDriveResourceItem[];
	shouldSaveGalleryConfig: boolean;
	dispatch: Dispatch<StoreState>;
	onClose: () => void;
}

export class MultiAppAuthenticationPopup extends React.Component<MultiAppAuthenticationPopupProps, never> {

	private accessibleAppsSelectRef: HTMLSelectElement | null;

	constructor(props: MultiAppAuthenticationPopupProps) {
		super(props);
		this.onSubmit = this.onSubmit.bind(this);
	}

	onSubmit(e: React.MouseEvent<HTMLButtonElement>): void {
		const { shouldSaveGalleryConfig, accessibleApps } = this.props;
		if (this.accessibleAppsSelectRef) {
			const { clientId, globalId } = accessibleApps[this.accessibleAppsSelectRef.selectedIndex];
			this.props.dispatch(loadGallery(clientId, globalId, shouldSaveGalleryConfig));
		}
	}

	render() {
		const { accessibleApps } = this.props;

		return (
			<div>
				<PageOverlay isOpen={true} />
				<StyledMultiAppAuthenticationPopup>
					<CloseButton onClick={() => this.props.onClose()}>
						{Utils.getSvgIcon('iconset_close-2')}
					</CloseButton>
					<MultiAppAuthenticationTitle><Translate value="messages.select_application" /></MultiAppAuthenticationTitle>
					<AccessibleAppSelectWrapper>
						<AccessibleAppSelect ref={ref => this.accessibleAppsSelectRef = ref}>
							{accessibleApps.map((accessibleApp, index) =>
								<option value={accessibleApp.globalId} key={index}>{accessibleApp.genericItemName}</option>
							)}
						</AccessibleAppSelect>
						<AccessibleAppSelectIcon>
							{Utils.getSvgIcon('iconset_down')}
						</AccessibleAppSelectIcon>
					</AccessibleAppSelectWrapper>
					<AuthenticateButton onClick={this.onSubmit}>
						<Translate value="messages.select_this_application" />
					</AuthenticateButton>
				</StyledMultiAppAuthenticationPopup>
			</div>
		);
	}
}

export default MultiAppAuthenticationPopup;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MultiAppAuthentication/Popup/index.tsx